import { createComponent, ComponentProps } from '@/internals/utils';
export type CardBodyProps = ComponentProps;

const CardBody = createComponent({ name: 'CardBody', componentAs: 'div' });

export default CardBody;
